<div [innerHTML]="jsonLD"></div>



<div class="product product--layout--{{ layout }}" *ngIf="product">


    <span class="d-md-none"
        style="font-size: 24px;  margin-bottom: 12px; font-weight: 700; display: block; color: #5e5351; line-height: 1.2;">{{
        product.name }}</span>

    <div class="product__content">

        <!-- .product__gallery -->
        <div class="product__gallery">
            <div class="product-gallery">

                <div class="product-gallery__featured">
                    <!-- (changed)="featuredCarouselTranslated($event)" -->

                    <owl-carousel-o [options]="carouselOptions" #featuredCarousel
                        (changed)="featuredCarouselTranslated($event)" ngSkipHydration>
                        <ng-template *ngFor="let image of images; let i = index" carouselSlide [id]="image.id">

                            <a appClick (click)="openPhotoSwipe($event, image);" [href]="image.url" target="_blank">
                                <img [src]="image.url" alt="{{product.name}}" #imageElement width="601" height="601"
                                    class="responsiveimg">
                            </a>
                            <!-- Quickstep Hydroseal -->
                            <div *ngIf="i == 0 && product.categorienaam == 'Laminaat'  && product.merknaam == 'QuickStep' && product.attributes[4].values[0].name != '-' "
                                style="position: absolute; top: 20px; right: 20px; display: block; z-index: 9; pointer-events: none;">
                                <img src="/assets/images/productlayer/hydroseal.png" alt="QuickStep Hydroseal"
                                    width="60" height="60">
                            </div>
                            <!-- Quickstep Hydroseal -->
                            <div *ngIf="i == 0 && product.categorienaam == 'PVC vloeren'  && product.merknaam == 'QuickStep Alpha' && product.attributes[4].values[0].name != '-' "
                                style="position: absolute; top: 20px; right: 20px; display: block; z-index: 9; pointer-events: none;">
                                <img src="/assets/images/productlayer/hydroseal.png" alt="QuickStep Hydroseal"
                                    width="60" height="60">
                            </div>
                            <!-- Beautifloor Hydroshield-->
                            <div *ngIf="i == 0 && product.categorienaam == 'Laminaat' && product.merknaam == 'Beautifloor' && product.attributes[4].values[0].name != '-' "
                                style="position: absolute; top: 20px; right: 20px; display: block; z-index: 9; pointer-events: none;">
                                <img src="/assets/images/productlayer/hydroshield.jpg" alt="QuickStep Hydroseal"
                                    width="100" height="51">
                            </div>
                            <!-- Meister Water resistant NIET lindura-->
                            <div *ngIf="i == 0 && product.categorienaam == 'Laminaat' && product.merknaam == 'Meister' && !product.serienaam.includes('Lindura') && product.attributes[4].values[0].name != '-' "
                                style="position: absolute; top: 20px; right: 20px; display: block; z-index: 9; pointer-events: none;">
                                <img src="/assets/images/productlayer/water-resistant.png" alt="Meister water resistant"
                                    width="63" height="85">
                            </div>
                            <!-- Meister Water resistant WEL lindura-->
                            <div *ngIf="i == 0 && product.categorienaam == 'Laminaat' && product.merknaam == 'Meister' && product.serienaam.includes('Lindura') && product.attributes[4].values[0].name != '-' "
                                style="position: absolute; top: 20px; right: 20px; display: block; z-index: 9; pointer-events: none;">
                                <img src="/assets/images/productlayer/water-resistant-24.png"
                                    alt="Meister water resistant" width="63" height="85">
                            </div>
                            <!-- In onze showrooom-->
                            <div *ngIf="i == 0 && product.showroom == 1 "
                                style="position: absolute; bottom: 20px; left: 20px;  display: block; z-index: 9; pointer-events: none; border: 1px #5e5351 solid;   padding: 5px 5px 5px 5px; border-radius: 8px;">
                                <div
                                    style="text-align: center;  padding: 5px 10px 5px 10px; background-color: #ffffff8c;">
                                    Te zien in<br>onze showroom</div>
                            </div>

                        </ng-template>

                    </owl-carousel-o>

                </div>


                <div class="product-gallery__carousel">
                    <owl-carousel-o [options]="thumbnailsCarouselOptions" [appFakeSlides]="images.length"
                        #fakeSlides="appFakeSlides" appOwlPreventClick #thumbnailsCarousel ngSkipHydration>
                        <ng-template *ngFor="let image of images" carouselSlide [id]="image.id">
                            <span class="product-gallery__carousel-item"
                                [ngClass]="{'product-gallery__carousel-item--active': image.active}" appClick
                                (click)="featuredCarousel.to(image.id); setActiveImage(image)">
                                <img class="product-gallery__carousel-image" [src]="image.url" alt="{{product.name}}"
                                    class="responsiveimg" width="89" height="89">
                            </span>
                        </ng-template>
                        <ng-template *ngFor="let i of fakeSlides.slides" carouselSlide [id]="'fake-slide-'+i">
                        </ng-template>
                    </owl-carousel-o>
                </div>
                <br><span style="float: left; fill: #d1d1d1; padding: 5px 10px 0px 0px; fill: #0090e3;">

                    <svg width="9px" viewBox="0 0 63 99" aria-hidden="true" focusable="false">
                        <path
                            d="M59.8 57.6l-38 38c-10.7 10.8-29.4-7-18.3-18l28-28L3.5 21C-8 9.5 12.2-6.5 21.7 3l38 38c4.4 5 4.4 12.3 0 16.6z">
                        </path>
                    </svg>

                </span> <a routerLink="/{{product.categorieslug | lowercase }}/{{product.slugserie}}">Bekijk de
                    volledige
                    {{ product.merknaam }} {{ product.serienaam }} collectie</a>



            </div>


            <br>

            <div class="container d-none d-md-block">

                <div class="row">

                    <div class="block-header" style="width: 100%;">
                        <span class="block-header__title">Plus-
                            en minpunten </span>


                    </div>
                    <span
                        style=" font-weight: bold; font-size: 20px; padding-bottom: 0px; padding-bottom: 3px; display: block;"></span>
                    <ul class="list" style="margin-bottom: 0px;">

                        <li *ngFor="let item of product.pluspunten; let i = index" class="list__item ">

                            <div class="icon-with-text">
                                <div class="icon-with-text__icon">


                                    <svg class="icon icon--color-green" aria-hidden="true" viewBox="0 0 99 99"
                                        focusable="false">

                                        <circle cx="49.5" cy="49.5" r="49.5"></circle>
                                        <path fill="#FFFFFF"
                                            d="M49.5 21c-3 0-5.5 2.3-5.5 5.2V44H26.2c-3 0-5.2 2.6-5.2 5.5 0 3 2.3 5.5 5.2 5.5H44v17.8c0 3 2.6 5.2 5.5 5.2 3 0 5.5-2.3 5.5-5.2V55h17.8c3 0 5.2-2.6 5.2-5.5 0-3-2.3-5.5-5.2-5.5H55V26.2c0-3-2.6-5.2-5.5-5.2z">
                                        </path>


                                    </svg>

                                </div>
                                <div class="icon-with-text__text">
                                    {{item}} </div>
                            </div>
                        </li>
                        <li *ngFor="let item of product.minpunten; let i = index" class="list__item ">

                            <div class="icon-with-text">
                                <div class="icon-with-text__icon">


                                    <svg class="icon icon--color-raingrey" aria-hidden="true" viewBox="0 0 99 99"
                                        focusable="false">

                                        <circle cx="49.5" cy="49.5" r="49.5"></circle>

                                        <path fill="#FFFFFF"
                                            d="M72.8 55c3 0 5.2-2.6 5.2-5.5 0-3-2.3-5.5-5.2-5.5H26.2c-3 0-5.2 2.6-5.2 5.5 0 3 2.3 5.5 5.2 5.5">
                                        </path>

                                    </svg>

                                </div>
                                <div class="icon-with-text__text">
                                    {{item}} </div>
                            </div>
                        </li>

                    </ul>



                </div>

            </div>
            <hr class="d-none d-md-block">
            <div class="short-div d-none d-md-block" style=" width: 100%;">
                <div style="padding: 0px 15px 15px 0px;  ">


                    <span class="block-header__title">Technische
                        informatie {{product.merknaam}} {{product.typenaam | lowercase }}</span>
                    <table style="width: 100%;">
                        <tbody>
                            <tr>
                                <td class="th-productinfo">Levertijd <div class="infotooltip">?</div>
                                </td>
                                <td>{{ product.availability }} dagen</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Uitvoering</td>
                                <td>{{ product.attributes[0].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Randafwerking</td>
                                <td>{{ product.attributes[1].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Fabrieksgarantie</td>
                                <td>{{ product.garantie }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Gebruikersklasse</td>
                                <td>{{ product.attributes[7].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Afmetingen <div class="infotooltip"
                                        tooltip="Lengte x breedte x hoogte" placement="right">?</div>
                                </td>
                                <td>{{ product.attributes[3].values[0].name }}</td>
                            </tr>
                            <tr *ngIf="product.ean != ''">
                                <td class="th-productinfo">EAN nummer</td>
                                <td>{{ product.ean }}</td>
                            </tr>
                            <tr *ngIf="product.slijtlaag != '0'">
                                <td class="th-productinfo">Slijtlaag</td>
                                <td>{{ product.slijtlaag }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Matlook</td>
                                <td>
                                    <div class="notavailable" *ngIf="product.matlook == 0; else elseBlock"></div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Vloerverwarming</td>
                                <td>
                                    <div class="notavailable"
                                        *ngIf="product.attributes[5].values[0].name == '-'; else elseBlock">
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Waterbestendig</td>
                                <td>
                                    <div class="notavailable"
                                        *ngIf="product.attributes[4].values[0].name == '-'; else elseBlock">
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Warmteweerstand</td>
                                <td>{{ product.attributes[6].values[0].name }}</td>
                            </tr>
                            <tr *ngIf="product.attributes[8].values[0].name != '0'">
                                <td class="th-productinfo">Planken per pak</td>
                                <td>{{ product.attributes[8].values[0].name }}</td>
                            </tr>

                            <tr *ngIf="product.categorieid == 2 ">
                                <td class="th-productinfo">Aangehechte ondervloer</td>
                                <td>
                                    <div class="notavailable"
                                        *ngIf="product.attributes[9].values[0].name != '1'; else elseBlock">
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </table>




                </div>
            </div>



        </div>

        <!-- .product__gallery / end -->
        <!-- .product__info -->
        <div class="product__info">
            <div class="product__wishlist-compare">
                <button type="button" class="btn btn-sm btn-light btn-svg-icon" data-toggle="tooltip"
                    data-placement="right" title="Wishlist" appClick (click)="addToWishlist()"
                    [ngClass]="{'btn-loading': addingToWishlist}">
                    <app-icon name="wishlist-16" size="16"></app-icon>
                </button>
                <button type="button" class="btn btn-sm btn-light btn-svg-icon" data-toggle="tooltip"
                    data-placement="right" title="Compare" appClick (click)="addToCompare()"
                    [ngClass]="{'btn-loading': addingToCompare}">
                    <app-icon name="compare-16" size="16"></app-icon>
                </button>
            </div>

            <a routerLink="/{{product.categorieslug| lowercase}}/{{product.slugmerk}}">
                <img src="/assets/images/logos/merk-{{ product.merknaam.replace(' ', '-').replace(' & ', '-').toLowerCase() }}.jpg"
                    class="d-none d-xl-block img-fluid" alt="Logo {{ product.merknaam }}" style="float: right;"></a>
            <h1 class="product__name d-none d-md-block">{{ product.name }}</h1>

        </div>


        <div class="product__sidebar">


            <div class="product__prices d-none d-md-block">
                <!-- <ng-container *ngIf="product.compareAtPrice">
                    <span class="product__new-price">{{ product.prijsm2|currencyFormat }}</span>{{ ' ' }}
                    <span class="product__old-price">{{ product.compareAtPrice|currencyFormat }}</span>
                </ng-container> -->

                {{ product.prijsm2|currencyFormat }} m<sup>2</sup>

                <ng-container *ngIf="product.prijsadvies">
                    <span style="padding-left: 10px;" class="product__old-price">{{ product.prijsadvies|currencyFormat}}
                        m<sup>2</sup></span>
                </ng-container>

                <br><span style="font-size: 16px; font-weight: normal; color: #000;">Levertijd:
                    {{ product.availability }} werkdagen</span>



            </div>

            <div class="product__prices d-md-none" style="text-align: right;">
                <ng-container>
                    <!-- <span class="product__new-price">{{ product.prijsm2|currencyFormat }}</span>{{ ' ' }} -->
                    <span class="product__old-price">{{ product.prijsadvies|currencyFormat }}</span>
                </ng-container>
                <ng-container *ngIf="!product.compareAtPrice">
                    {{ product.prijsm2|currencyFormat }} m<sup>2</sup>
                    <br><span style="font-size: 16px; font-weight: normal; color: #000;">Levertijd:
                        {{ product.availability }} werkdagen</span>
                </ng-container>

            </div>


            <div *ngIf="this.blackfridayactie" class="mt-3 d-block d-sm-none" style="width: 100%; text-align: center;">
                <img class="img-fluid" src="/assets/images/actie/blackfriday-374.jpg">
            </div>

            <div *ngIf="this.blackfridayactie" class="mt-3 d-none d-sm-block d-md-none">
                <img class="img-fluid" src="/assets/images/actie/blackfriday-608.jpg">
            </div>

            <!-- <div class="short-div d-md-none" *ngIf="product.badges.includes('gratisondervloerfloorify')">

                <img src="/assets/images/banners/floorify-ondervloer-mobile.jpg" class="responsiveimg"
                    style=" margin-right: 7px;" alt="Gratis ondervloer {{product.serienaam }}">
            </div> -->

            <!-- <div class="short-div d-md-none"  *ngIf="product.badges.includes('gratisstalenfloorify')">

                <img src="/assets/images/banners/floorify-stalen-mobile.jpg" class="responsiveimg" style=" margin-right: 7px;" alt="Gratis stalen {{product.serienaam }}">
           </div> -->

            <div class="short-div d-md-none" *ngIf="product.badges[0] != ''">

                <img src="/assets/images/banners/{{product.badges[0]}}-mobile.jpg" class="responsiveimg"
                    style=" margin-right: 7px;" alt="Actie banner {{product.serienaam }}">

            </div>



            <br>

            <div class="product__description">
                <ng-container *ngIf="product.gratisondervloertitle">

                    <img src="/assets/images/icons/actie-right.svg" alt="Actie"
                        *ngIf="product.gratisondervloertitle == 'Gratis decoupeerzaag'"
                        style="float: left; margin-right: 10px; margin-bottom: 55px; margin-top: 10px;">
                    <span style="color: #305696; font-weight: bold; font-size: 20px;">{{product.gratisondervloertitle}}
                    </span><br>
                    <span innerHTML="{{ product.gratisvloer }}" (click)="getRoute($event)"></span>

                    <!-- De gratis ondervloer wordt direct getoond in de winkelmand. -->
                </ng-container>
                <ng-container *ngIf="!product.gratisondervloertitle">
                    <span style="color: #305696; font-weight: bold; font-size: 20px;">Combinatie korting
                    </span><br>
                    <span innerHTML="{{ product.gratisvloer }}" (click)="getRoute($event)"></span>

                    Koop jouw ondervloer naar keuze met extra voordeel, via onze <a href="javascript:void(0)"
                        (click)="gotoAnchor('block-combinatiekorting')">combinatie korting</a>.<br>
                    Kies het aantal pakken en zie direct de korting per ondervloer.
                </ng-container>


            </div>
            <br>
            <br>

            <div class="product__description">

                <app-m2-calculator (notifyParent)="getMessage($event)" [product]="product"></app-m2-calculator>
                <!-- <span style="font-weight: bold; font-size: 20px;">Bereken prijs</span> -->
                <br><br>
                <span style="font-weight: bold; font-size: 20px;">Teveel besteld?</span><br>
                Gratis <a routerLink="/klantenservice/retourneren">ophaalservice</a> volle pakken
                laminaat. Prijs per pak van {{product.m2}} m<sup>2</sup> slechts
                {{product.prijspak|currencyFormat}}.<br>

                <ng-container *ngIf="product.attributes[0].values[0].name != 'Visgraat'">
                    <i>Bereken 5% extra snijverlies.</i>
                </ng-container>
                <ng-container *ngIf="product.attributes[0].values[0].name == 'Visgraat'">
                    <i>Bereken 10% extra snijverlies.</i>
                </ng-container>

            </div>
            <br>





            <form class="product__options">



                <br>
                <div class="form-group product__option">

                    <app-calculate-m2 [receivedParentMessage]="messageToSendP" aria-label="Hoeveel" size="lg" [min]="1"
                        [uitvoeringtype]="product.uitvoeringtype" [formControl]="quantity"
                        (valueChange)="displaySum($event, this.product.combinatieondervloerm2[combinatieondervloer.value])"
                        [m2]="product.m2" [prijspak]="product.prijspak">
                    </app-calculate-m2>



                </div>




                <div class="form-group product__option">

                    <div class="product__actions" style="float: right;">
                        <div class="product__actions-item product__actions-item--wishlist">
                            <button type="button" class="btn btn-secondary btn-svg-icon btn-lg"
                                tooltip="Zet dit product op je wensenlijstje"
                                [ngClass]="{'btn-loading': addingToWishlist}" appClick (click)="addToWishlist()">
                                <app-icon name="wishlist-16" size="16"></app-icon>
                            </button>
                        </div>
                        <div class="product__actions-item product__actions-item--addtocart"
                            style="width: 100%; padding-left: 15px;">
                            <button type="button" class="btn btn-primary btn-lg" style="width: 100%;"
                                [ngClass]="{'btn-loading': addingToCart}" appClick (click)="addToCart()">

                                Plaats in winkelmand</button>


                        </div>


                    </div>
                </div>
            </form>
            <!-- .product__options / end -->
            <br>
            <br>
            <br>
            <div class="form-group">
                <div class="form-check">
                    <span class="form-check-input input-check">
                        <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" data-toggle="tooltip" title="Vergelijken"
                                appClick (click)="toggleCompare()" [(ngModel)]="onCompareList"> <!-- checked -->
                            <span class="input-check__box"></span>
                            <app-icon class="input-check__icon" name="check-9x7" size="9x7"></app-icon>
                        </span>
                    </span>
                    <label class="form-check-label" for="login-remember"><span *ngIf="!onCompareList">Voeg
                            {{product.merknaam}} {{product.typenaam }} toe aan
                            vergelijking.</span><span *ngIf="onCompareList">Toegevoegd aan
                            vergelijking.</span></label>&nbsp;<a *ngIf="anyOnCompareList || onCompareList"
                        routerLink="/vergelijken">Bekijk vergelijking</a>
                </div>
            </div>


            <div class="checkmark" style="float: left; margin-right: 10px;"></div><a
                routerLink="/klantenservice/bezorgen-afhalen" class="black"> <span class="orangebold">Bezorging</span>
                tot
                achter de deur</a><br>
            <div class="checkmark" style="float: left; margin-right: 10px;"></div><a
                routerLink="/klantenservice/betaalmogelijkheden" class="black"
                style="font-weight: bold; color: #009600;"> iDeal
                betaling <span class="orangebold" style="color: #009600;">extra {{ this.iDealKortingPercentage * 100 |
                    number: '1.0-0' }}% voordeel</span></a><br>
            <div class="checkmark" style="float: left; margin-right: 10px;"></div><a
                routerLink="/klantenservice/retourneren" class="black"> <span class="orangebold">Gratis</span>
                binnen 30
                dagen ophaalservice</a><br>
            <div class="checkmark" style="float: left; margin-right: 10px;"></div><a
                href="https://www.feedbackcompany.com/nl-nl/reviews/voordeelvloeren-nl" class="black" target="_blank"
                rel="nofollow"> Klanten
                geven Voordeelvloeren&nbsp;<span class="orangebold"><ng-container
                        *ngIf="fbcreviews">{{fbcreviews['score']}}</ng-container></span></a><br>



            <!-- <div class="short-div d-md-none" *ngIf="product.badges.includes('20coreteckorting')">
                <br>
                <img src="/assets/images/banners/coretec-korting20mobile.jpg" class="responsiveimg"
                    style=" margin-right: 7px;" alt="COREtec korting {{product.serienaam }}">


            </div> -->




            <div class="short-div d-md-none" style=" width: 100%;">
                <hr>
                <div style="padding: 0px 15px 0px 0px;  ">

                    <span class="block-header__title">Technische
                        informatie {{product.merknaam}} {{product.typenaam | lowercase }} </span>
                    <table style="width: 100%;">
                        <tbody>

                            <tr>
                                <td class="th-productinfo">Levertijd</td>
                                <td>{{ product.availability }} dagen</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Uitvoering</td>
                                <td>{{ product.attributes[0].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Randafwerking</td>
                                <td>{{ product.attributes[1].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Fabrieksgarantie</td>
                                <td>{{ product.garantie }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Gebruikersklasse</td>
                                <td>{{ product.attributes[7].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Afmetingen</td>
                                <td>{{ product.attributes[3].values[0].name }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">EAN nummer</td>
                                <td>{{ product.ean }}</td>
                            </tr>
                            <tr *ngIf="product.slijtlaag != '0'">
                                <td class="th-productinfo">Slijtlaag</td>
                                <td>{{ product.slijtlaag }}</td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Matlook</td>
                                <td>
                                    <div class="notavailable" *ngIf="product.matlook == 0; else elseBlock"></div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Vloerverwarming</td>
                                <td>
                                    <div class="notavailable"
                                        *ngIf="product.attributes[5].values[0].name == '-'; else elseBlock">
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Waterbestendig</td>
                                <td>
                                    <div class="notavailable"
                                        *ngIf="product.attributes[4].values[0].name == '-'; else elseBlock">
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="checkmark"></div>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td class="th-productinfo">Warmteweerstand</td>
                                <td>{{ product.attributes[6].values[0].name }}</td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>


            <div *ngIf="this.blackfridayactie" class="mt-3 d-none d-md-block d-lg-none">
                <img class="img-fluid" src="/assets/images/actie/blackfriday-374.jpg">
            </div>

            <div *ngIf="this.blackfridayactie" class="mt-3 d-none d-lg-block">
                <img class="img-fluid" src="/assets/images/actie/blackfriday-608.jpg">
            </div>


            <div style="margin: 26px 0px 5px 0px; padding: 8px 0px 8px 0px; background-color: #f8f4ee;"
                class="row d-none d-md-block">


                <div class="col-12 text-center">


                    <div style="padding-top: 5px;">
                        <a href="https://www.feedbackcompany.com/nl-nl/reviews/voordeelvloeren-nl" rel="nofollow"
                            target="_blank">
                            <div style="padding-top: 3px;">
                                <img src="/assets/images/global/ratingstar.svg" alt="Rating"
                                    style="vertical-align: top;" width="16" height="16">
                                <img src="/assets/images/global/ratingstar.svg" alt="Rating"
                                    style="vertical-align: top;" width="16" height="16">
                                <img src="/assets/images/global/ratingstar.svg" alt="Rating"
                                    style="vertical-align: top;" width="16" height="16">
                                <img src="/assets/images/global/ratingstar.svg" alt="Rating"
                                    style="vertical-align: top;" width="16" height="16">
                                <img src="/assets/images/global/ratingstar.svg" alt="Rating"
                                    style="vertical-align: top;" width="16" height="16">
                            </div>
                        </a>
                    </div>


                    <div>&nbsp;<a href="https://www.feedbackcompany.com/nl-nl/reviews/voordeelvloeren-nl"
                            target="_blank" rel="nofollow" class="blacklink">
                            <ng-container *ngIf="fbcreviews">{{fbcreviews['score']}}</ng-container> / <ng-container
                                *ngIf="fbcreviews">{{fbcreviews['total']}}</ng-container> van
                            <ng-container *ngIf="fbcreviews">{{fbcreviews['count']}}</ng-container> beoordelingen
                        </a>
                    </div>


                    <svg style="margin: auto;" width="100px" height="51px" viewBox="0 0 251 71" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
                        <title>FBC-logo</title>
                        <desc>Created with Sketch.</desc>
                        <defs>
                            <linearGradient x1="-12.3982067%" y1="-10.4568059%" x2="85.5188112%" y2="99.2080422%"
                                id="linearGradient-1">
                                <stop stop-color="#6590FF" offset="0%"></stop>
                                <stop stop-color="#4DC9E2" offset="50.707348%"></stop>
                                <stop stop-color="#35FFC6" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Atom/Logos/Logo/Complete/Colored" fill-rule="nonzero">
                                <g id="FBC-logo">
                                    <path
                                        d="M115.557,16.675 L111.417,16.675 L111.417,30.616 L106.634,30.616 L106.634,16.675 L104,16.675 L104,14.37 L106.634,13.084 L106.634,11.798 C106.634,9.801 107.126,8.343 108.108,7.423 C109.091,6.503 110.664,6.043 112.828,6.043 C114.48,6.043 115.948,6.288 117.235,6.779 L116.012,10.292 C115.05,9.989 114.161,9.838 113.346,9.838 C112.666,9.838 112.175,10.039 111.872,10.441 C111.569,10.844 111.417,11.358 111.417,11.986 L111.417,13.084 L115.557,13.084 L115.557,16.675"
                                        id="Fill-3510" fill="#303C50"></path>
                                    <path
                                        d="M125.327,16.445 C124.313,16.445 123.518,16.766 122.944,17.41 C122.368,18.053 122.039,18.965 121.956,20.146 L128.667,20.146 C128.646,18.965 128.337,18.053 127.742,17.41 C127.146,16.766 126.341,16.445 125.327,16.445 Z M126.002,31.217 C123.179,31.217 120.973,30.439 119.382,28.881 C117.795,27.323 117,25.117 117,22.263 C117,19.326 117.735,17.055 119.203,15.45 C120.671,13.844 122.703,13.043 125.296,13.043 C127.774,13.043 129.702,13.748 131.082,15.159 C132.462,16.571 133.151,18.52 133.151,21.009 L133.151,23.33 L121.846,23.33 C121.898,24.689 122.299,25.75 123.053,26.513 C123.806,27.276 124.862,27.658 126.221,27.658 C127.277,27.658 128.276,27.549 129.215,27.329 C130.157,27.109 131.14,26.759 132.164,26.278 L132.164,29.979 C131.328,30.397 130.434,30.708 129.483,30.912 C128.531,31.116 127.371,31.217 126.002,31.217 L126.002,31.217 Z"
                                        id="Fill-3511" fill="#303C50"></path>
                                    <path
                                        d="M144.327,16.445 C143.313,16.445 142.518,16.766 141.943,17.41 C141.368,18.053 141.039,18.965 140.955,20.146 L147.667,20.146 C147.646,18.965 147.338,18.053 146.742,17.41 C146.146,16.766 145.34,16.445 144.327,16.445 Z M145.001,31.217 C142.178,31.217 139.972,30.439 138.383,28.881 C136.794,27.323 136,25.117 136,22.263 C136,19.326 136.734,17.055 138.203,15.45 C139.672,13.844 141.702,13.043 144.295,13.043 C146.773,13.043 148.702,13.748 150.082,15.159 C151.462,16.571 152.152,18.52 152.152,21.009 L152.152,23.33 L140.845,23.33 C140.898,24.689 141.299,25.75 142.053,26.513 C142.805,27.276 143.862,27.658 145.22,27.658 C146.277,27.658 147.275,27.549 148.216,27.329 C149.157,27.109 150.139,26.759 151.164,26.278 L151.164,29.979 C150.327,30.397 149.434,30.708 148.483,30.912 C147.53,31.116 146.37,31.217 145.001,31.217 L145.001,31.217 Z"
                                        id="Fill-3512" fill="#303C50"></path>
                                    <path
                                        d="M163.295,26.947 C164.519,26.947 165.415,26.591 165.985,25.881 C166.553,25.17 166.866,23.963 166.918,22.258 L166.918,21.741 C166.918,19.859 166.628,18.511 166.048,17.695 C165.468,16.88 164.524,16.472 163.217,16.472 C162.151,16.472 161.322,16.924 160.731,17.828 C160.14,18.732 159.846,20.047 159.846,21.772 C159.846,23.497 160.143,24.791 160.739,25.653 C161.335,26.515 162.187,26.947 163.295,26.947 Z M161.617,30.757 C159.558,30.757 157.94,29.958 156.764,28.358 C155.588,26.758 155,24.543 155,21.71 C155,18.835 155.598,16.595 156.795,14.99 C157.992,13.384 159.641,12.583 161.743,12.583 C163.949,12.583 165.632,13.44 166.792,15.154 L166.95,15.154 C166.709,13.847 166.589,12.681 166.589,11.657 L166.589,6.043 L171.388,6.043 L171.388,30.444 L167.718,30.444 L166.792,28.171 L166.589,28.171 C165.501,29.895 163.844,30.757 161.617,30.757 L161.617,30.757 Z"
                                        id="Fill-3513" fill="#303C50"></path>
                                    <path
                                        d="M185.217,16.409 C184.036,16.409 183.173,16.772 182.63,17.499 C182.086,18.225 181.804,19.426 181.783,21.097 L181.783,21.615 C181.783,23.497 182.062,24.845 182.621,25.661 C183.181,26.476 184.067,26.884 185.28,26.884 C186.263,26.884 187.044,26.432 187.623,25.528 C188.205,24.624 188.495,23.308 188.495,21.584 C188.495,19.859 188.202,18.565 187.617,17.703 C187.031,16.84 186.231,16.409 185.217,16.409 Z M186.754,12.583 C188.824,12.583 190.444,13.39 191.615,15.006 C192.786,16.621 193.372,18.835 193.372,21.646 C193.372,24.543 192.767,26.785 191.56,28.374 C190.353,29.964 188.709,30.757 186.628,30.757 C184.569,30.757 182.954,30.01 181.783,28.515 L181.454,28.515 L180.654,30.444 L177,30.444 L177,6.043 L181.783,6.043 L181.783,11.72 C181.783,12.441 181.72,13.596 181.595,15.185 L181.783,15.185 C182.901,13.45 184.559,12.583 186.754,12.583 L186.754,12.583 Z"
                                        id="Fill-3514" fill="#303C50"></path>
                                    <path
                                        d="M206.883,22.813 L205.033,22.875 C203.642,22.917 202.607,23.168 201.928,23.628 C201.248,24.088 200.909,24.789 200.909,25.73 C200.909,27.079 201.682,27.752 203.23,27.752 C204.336,27.752 205.224,27.434 205.888,26.796 C206.551,26.159 206.883,25.312 206.883,24.255 L206.883,22.813 Z M208.294,30.936 L207.37,28.552 L207.244,28.552 C206.439,29.567 205.61,30.27 204.758,30.662 C203.906,31.053 202.795,31.249 201.426,31.249 C199.743,31.249 198.417,30.769 197.451,29.807 C196.483,28.845 196,27.476 196,25.699 C196,23.837 196.651,22.465 197.953,21.582 C199.254,20.699 201.217,20.21 203.841,20.116 L206.883,20.021 L206.883,19.254 C206.883,17.476 205.974,16.588 204.155,16.588 C202.752,16.588 201.107,17.01 199.215,17.857 L197.631,14.626 C199.647,13.571 201.886,13.043 204.343,13.043 C206.695,13.043 208.499,13.555 209.753,14.58 C211.008,15.604 211.635,17.163 211.635,19.254 L211.635,30.936 L208.294,30.936 L208.294,30.936 Z"
                                        id="Fill-3515" fill="#303C50"></path>
                                    <path
                                        d="M223.186,31.217 C217.728,31.217 215,28.222 215,22.232 C215,19.253 215.742,16.976 217.226,15.402 C218.711,13.829 220.839,13.043 223.609,13.043 C225.637,13.043 227.456,13.44 229.066,14.234 L227.654,17.935 C226.902,17.632 226.202,17.384 225.553,17.19 C224.905,16.997 224.256,16.9 223.609,16.9 C221.121,16.9 219.877,18.667 219.877,22.201 C219.877,25.63 221.121,27.344 223.609,27.344 C224.528,27.344 225.381,27.221 226.165,26.975 C226.949,26.73 227.733,26.346 228.517,25.823 L228.517,29.916 C227.743,30.408 226.962,30.747 226.173,30.935 C225.382,31.124 224.388,31.217 223.186,31.217"
                                        id="Fill-3516" fill="#303C50"></path>
                                    <polyline id="Fill-3517" fill="#303C50"
                                        points="237.594 20.91 239.679 18.244 244.589 12.912 249.984 12.912 243.021 20.517 250.407 30.444 244.887 30.444 239.838 23.341 237.783 24.987 237.783 30.444 233 30.444 233 6.043 237.783 6.043 237.783 16.926 237.532 20.91 237.594 20.91">
                                    </polyline>
                                    <path
                                        d="M112.826,61.858 C110.337,61.858 108.411,61.092 107.047,59.561 C105.682,58.029 105,55.863 105,53.06 C105,50.186 105.693,47.964 107.078,46.396 C108.463,44.827 110.435,44.043 112.998,44.043 C113.824,44.043 114.65,44.132 115.476,44.31 C116.301,44.488 116.95,44.697 117.42,44.937 L116.62,47.148 C116.045,46.918 115.418,46.728 114.739,46.575 C114.059,46.424 113.457,46.349 112.935,46.349 C109.443,46.349 107.697,48.575 107.697,53.029 C107.697,55.141 108.123,56.761 108.976,57.89 C109.828,59.02 111.09,59.584 112.763,59.584 C114.195,59.584 115.664,59.276 117.169,58.658 L117.169,60.964 C116.019,61.56 114.571,61.858 112.826,61.858"
                                        id="Fill-3518" fill="#303C50"></path>
                                    <path
                                        d="M122.698,52.935 C122.698,55.13 123.138,56.803 124.016,57.953 C124.894,59.103 126.185,59.678 127.889,59.678 C129.593,59.678 130.887,59.106 131.771,57.961 C132.654,56.816 133.096,55.141 133.096,52.935 C133.096,50.75 132.654,49.09 131.771,47.955 C130.887,46.822 129.583,46.254 127.858,46.254 C126.154,46.254 124.868,46.814 124,47.932 C123.132,49.051 122.698,50.718 122.698,52.935 Z M135.793,52.935 C135.793,55.737 135.087,57.924 133.676,59.497 C132.265,61.072 130.313,61.858 127.827,61.858 C126.29,61.858 124.925,61.497 123.733,60.776 C122.542,60.054 121.622,59.02 120.974,57.671 C120.325,56.323 120,54.743 120,52.935 C120,50.133 120.702,47.95 122.103,46.388 C123.503,44.825 125.448,44.043 127.935,44.043 C130.341,44.043 132.251,44.843 133.668,46.443 C135.083,48.042 135.793,50.206 135.793,52.935 L135.793,52.935 Z"
                                        id="Fill-3519" fill="#303C50"></path>
                                    <path
                                        d="M162.909,61.544 L162.909,50.363 C162.909,48.993 162.616,47.966 162.031,47.282 C161.445,46.597 160.536,46.254 159.302,46.254 C157.682,46.254 156.484,46.72 155.711,47.65 C154.936,48.58 154.55,50.013 154.55,51.947 L154.55,61.544 L151.947,61.544 L151.947,50.363 C151.947,48.993 151.654,47.966 151.069,47.282 C150.483,46.597 149.569,46.254 148.325,46.254 C146.694,46.254 145.499,46.743 144.741,47.721 C143.983,48.699 143.603,50.3 143.603,52.527 L143.603,61.544 L141,61.544 L141,44.357 L143.118,44.357 L143.541,46.709 L143.667,46.709 C144.159,45.872 144.851,45.219 145.745,44.749 C146.639,44.279 147.64,44.043 148.747,44.043 C151.435,44.043 153.191,45.016 154.017,46.96 L154.143,46.96 C154.655,46.061 155.397,45.35 156.37,44.827 C157.342,44.305 158.45,44.043 159.694,44.043 C161.639,44.043 163.094,44.542 164.061,45.54 C165.028,46.539 165.512,48.136 165.512,50.331 L165.512,61.544 L162.909,61.544"
                                        id="Fill-3520" fill="#303C50"></path>
                                    <path
                                        d="M178.622,46.254 C176.865,46.254 175.595,46.741 174.811,47.713 C174.027,48.685 173.623,50.233 173.603,52.355 L173.603,52.935 C173.603,55.35 174.006,57.077 174.811,58.117 C175.616,59.158 176.907,59.678 178.684,59.678 C180.169,59.678 181.332,59.077 182.174,57.874 C183.015,56.672 183.436,55.015 183.436,52.904 C183.436,50.76 183.015,49.116 182.174,47.972 C181.332,46.826 180.148,46.254 178.622,46.254 Z M178.998,61.858 C177.879,61.858 176.856,61.652 175.932,61.239 C175.007,60.825 174.23,60.191 173.603,59.333 L173.415,59.333 C173.54,60.337 173.603,61.288 173.603,62.187 L173.603,69.26 L171,69.26 L171,44.357 L173.117,44.357 L173.478,46.709 L173.603,46.709 C174.272,45.768 175.051,45.089 175.94,44.67 C176.829,44.252 177.848,44.043 178.998,44.043 C181.277,44.043 183.036,44.823 184.275,46.38 C185.514,47.938 186.133,50.122 186.133,52.935 C186.133,55.757 185.503,57.95 184.244,59.513 C182.984,61.076 181.235,61.858 178.998,61.858 L178.998,61.858 Z"
                                        id="Fill-3521" fill="#303C50"></path>
                                    <path
                                        d="M194.976,59.677 C196.596,59.677 197.869,59.233 198.794,58.344 C199.72,57.456 200.182,56.211 200.182,54.612 L200.182,53.06 L197.579,53.169 C195.509,53.243 194.017,53.564 193.102,54.134 C192.187,54.704 191.73,55.589 191.73,56.792 C191.73,57.733 192.014,58.449 192.584,58.94 C193.154,59.432 193.951,59.677 194.976,59.677 Z M200.856,61.512 L200.339,59.066 L200.213,59.066 C199.356,60.143 198.501,60.872 197.649,61.253 C196.797,61.635 195.734,61.826 194.459,61.826 C192.754,61.826 191.417,61.387 190.452,60.508 C189.484,59.63 189,58.381 189,56.76 C189,53.29 191.777,51.47 197.328,51.303 L200.245,51.209 L200.245,50.143 C200.245,48.794 199.955,47.798 199.374,47.156 C198.794,46.512 197.866,46.191 196.591,46.191 C195.159,46.191 193.538,46.63 191.73,47.508 L190.93,45.517 C191.777,45.057 192.705,44.696 193.712,44.435 C194.722,44.173 195.734,44.043 196.748,44.043 C198.797,44.043 200.315,44.498 201.303,45.407 C202.291,46.317 202.785,47.775 202.785,49.782 L202.785,61.512 L200.856,61.512 L200.856,61.512 Z"
                                        id="Fill-3522" fill="#303C50"></path>
                                    <path
                                        d="M219.761,61.544 L219.761,50.426 C219.761,49.025 219.442,47.98 218.805,47.289 C218.167,46.599 217.168,46.254 215.81,46.254 C214.011,46.254 212.694,46.741 211.857,47.713 C211.021,48.685 210.602,50.29 210.602,52.527 L210.602,61.544 L208,61.544 L208,44.357 L210.117,44.357 L210.54,46.709 L210.665,46.709 C211.199,45.863 211.946,45.206 212.908,44.742 C213.87,44.276 214.941,44.043 216.122,44.043 C218.193,44.043 219.75,44.542 220.796,45.54 C221.841,46.539 222.364,48.136 222.364,50.331 L222.364,61.544 L219.761,61.544"
                                        id="Fill-3523" fill="#303C50"></path>
                                    <path
                                        d="M225,45.043 L227.792,45.043 L231.556,54.844 C232.381,57.082 232.893,58.697 233.092,59.69 L233.218,59.69 C233.353,59.157 233.639,58.245 234.073,56.953 C234.506,55.662 235.925,51.692 238.33,45.043 L241.121,45.043 L233.735,64.614 C233.003,66.548 232.149,67.92 231.171,68.73 C230.194,69.541 228.993,69.946 227.572,69.946 C226.778,69.946 225.993,69.857 225.22,69.679 L225.22,67.594 C225.795,67.719 226.438,67.782 227.149,67.782 C228.937,67.782 230.212,66.778 230.974,64.77 L231.932,62.324 L225,45.043"
                                        id="Fill-3524" fill="#303C50"></path>
                                    <g id="Atom/Logos/Logo/Mark/Colored" fill="url(#linearGradient-1)">
                                        <path
                                            d="M28.372,30.043 C29.6,30.043 30.595,31.038 30.595,32.265 C30.595,33.493 29.6,34.488 28.372,34.488 L24.668,34.488 C23.442,34.488 22.446,35.485 22.446,36.71 L22.446,64.32 L28.89,60.047 C29.254,59.805 29.681,59.676 30.118,59.676 L45.412,59.676 C46.637,59.676 47.634,58.679 47.634,57.454 L47.634,46.717 C47.634,45.49 48.629,44.494 49.856,44.494 C51.084,44.494 52.079,45.49 52.079,46.717 L52.079,57.454 C52.079,61.13 49.088,64.121 45.412,64.121 L30.788,64.121 L21.452,70.314 C21.081,70.559 20.652,70.684 20.223,70.684 C19.862,70.684 19.501,70.596 19.172,70.42 C18.451,70.032 18,69.28 18,68.461 L18,36.71 C18,33.034 20.992,30.043 24.668,30.043 L28.372,30.043 Z M28.247,11.043 C29.409,11.043 30.469,11.879 30.584,13.035 C30.718,14.366 29.676,15.488 28.374,15.488 L6.667,15.488 C5.44,15.488 4.446,16.483 4.446,17.71 L4.446,45.32 L8.737,42.474 C9.87,41.722 11.406,42.155 11.981,43.387 C12.445,44.384 12.11,45.57 11.194,46.178 L3.452,51.313 C3.081,51.559 2.652,51.683 2.223,51.683 C1.862,51.683 1.502,51.596 1.172,51.419 C0.451,51.032 5.15143483e-13,50.279 5.15143483e-13,49.461 L5.15143483e-13,17.71 C5.15143483e-13,14.028 2.986,11.043 6.667,11.043 L28.247,11.043 Z M68.231,0.043 C71.908,0.043 74.899,3.034 74.899,6.71 L74.899,43.127 C74.899,43.946 74.449,44.698 73.728,45.085 C73.397,45.262 73.037,45.35 72.676,45.35 C72.247,45.35 71.819,45.225 71.448,44.979 L60.836,37.941 L43.667,37.941 C39.992,37.941 37,34.95 37,31.273 L37,6.71 C37,3.034 39.992,0.043 43.667,0.043 L68.231,0.043 Z M68.231,4.488 L43.667,4.488 C42.443,4.488 41.446,5.485 41.446,6.71 L41.446,31.273 C41.446,32.499 42.443,33.496 43.667,33.496 L61.506,33.496 C61.943,33.496 62.37,33.625 62.734,33.867 L70.454,38.986 L70.454,6.71 C70.454,5.485 69.457,4.488 68.231,4.488 Z"
                                            id="Combined-Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>




            <div class="row">
                <div class="container">


                    <!-- <div class="d-none d-md-block" *ngIf="product.badges.includes('20coreteckorting')">

                        <img src="/assets/images/banners/coretec-korting20desktop.jpg" class="responsiveimg"
                            style=" margin-right: 7px;" alt="COREtec korting {{product.serienaam }}">

                    </div> -->

                    <!-- <div class="d-none d-md-block" *ngIf="product.badges.includes('gratisondervloerfloorify')">

                        <img src="/assets/images/banners/floorify-ondervloer-desktop.jpg" class="responsiveimg"
                            style=" margin-right: 7px;" alt="Gratis floorify ondervloer {{product.serienaam }}">

                    </div> -->

                    <div class="d-none d-md-block" *ngIf="product.badges[0] != ''">

                        <img src="/assets/images/banners/{{product.badges[0]}}-desktop.jpg" class="responsiveimg"
                            style=" margin-right: 7px;" alt="Actie banner {{product.serienaam }}">

                    </div>





                    <div class="d-none d-md-block"
                        *ngIf="product.brochurepdf?.length && !product.badges.includes('20coreteckorting') && !product.badges.includes('gratisondervloerfloorify') && product.badges[0] == ''">
                        <div style="width: 100%; padding: 16px 16px 16px 0px; display: flow-root;">

                            <div style=" float:left; margin:10px 10px 10px 0px;">
                                <a href="https://downloads.voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf"
                                    class="black" target="_blank">
                                    <img src="/assets/images/brochure/{{product.brochurepdf}}.jpg" width="230"
                                        height="319" style=" margin-right: 7px;" alt="Brochure {{
                                            product.merknaam }} {{
                                            product.serienaam }}">
                                </a>
                            </div>
                            <div style="padding-top: 10px;">
                                <span style="font-weight: bold; font-size: 20px;">Brochure 2025</span><br><br>

                                Blader op je gemak door de nieuwste {{ product.brochurenaam }}
                                en laat je inspireren door de nieuwste trends.<br><Br>

                                {{ product.merknaam }} heeft een volledig assortiment gereedschappen om je vloer
                                makkelijk
                                te
                                leggen en accessoires om de {{ product.merknaam }} vloer af te werken.<br><br>
                            </div>


                            <div>


                                <img src="/assets/images/logos/pdf.svg" class="img-fluid" alt="PDF download"
                                    width="15px" style="vertical-align: unset;">&nbsp;&nbsp;<a
                                    href="https://downloads.Voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf"
                                    target="_blank">Download {{ product.brochurenaam }}</a>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>





    <br>





    <div class="row" style=" padding: 5px 0px 20px 0px;">
        <div class="col-12" style="padding-bottom: 10px;" id="block-combinatiekorting">

            <div class="block-header" style="margin-bottom: 0px;">


                <img src="/assets/images/icons/round-check.svg" class="icon-check" alt="checkmark">

                <span class="block-header__title" style="color: #305696; margin-bottom: 12px;">Combinatie
                    korting</span>
                <div class="block-header__divider" style="margin-bottom: 10px;"></div>
            </div>



            Voordeelvloeren is voordelig met <a routerLink="/laminaat">laminaat</a> en <a routerLink="/pvc-vloeren">PCV
                vloeren</a> maar ook met alle toebehoren zoals plinten, profielen en ondervloeren. Maak je een
            combinatie van een <b>vloer + ondervloer</b> kunnen we vaak nog extra korting geven op de prijs van de
            ondervloer.





            <div [innerHTML]="longText" *ngIf="readMore" style="float: left; display: contents;">


            </div>
            <a *ngIf="readMore" href="javascript:;" (click)="readMore=false">Minder informatie</a>



            <a href="javascript:;" *ngIf="!readMore" (click)="readMore=true">Meer informatie</a>


        </div>

        <div class="col-12 col-md-4"> <span
                style="font-size: 18px; float: left; font-weight: bold; background-color: #305696; width: 100%; margin-bottom: 8px; padding: 3px 0px 3px 5px; color: #fff; text-align: center;">
                Vloer

                <div style="float: right; z-index: 999; position: relative; left: 25px; top: 151px"
                    class="d-none d-lg-block">

                    <img src="/assets/images/icons/round-plus.svg" style="vertical-align: text-top; width: 25px; "
                        alt="plus icon">

                </div>
            </span>
            <div style="border: 1px solid #305696; padding: 8px; margin-bottom: 14px; height: 100%;
            display: inherit; ">


                <div style="text-align: center; width: 100%; display: block;"><img src="{{product.images[0]}}"
                        style="margin-right: 10px; border: 1px solid rgb(240, 235, 226);" width="110" height="110"
                        alt="{{product.merknaam}} {{product.typenaam}}">
                    <br> <br>
                </div>
                <div style="display: table; margin: auto; height: 60px;">
                    <strong style="padding-top: 4px;
                        display: block;">{{ this.aantalpak }}x {{product.merknaam}} {{product.typenaam
                        }}</strong>Warmteweerstand {{ product.warmteweerstand }} K/W
                    <br>


                </div>

                <div style="display: table; margin: auto; height: 60px;">
                    <span class="orangebold" style="font-size: 24px;">{{ product.prijsm2 | currencyFormat }}
                        m<sup>2</sup></span>

                </div>


                <input class="form-control input-number__input" type="hidden" [value]="value" #inputElement>


                <div class="row">
                    <div class="col-6 px-1">
                        <div style=" text-align: right; padding-top: 14px; padding-right: 2px;">
                            Aantal pak:
                        </div>
                    </div>
                    <div class="col-6 px-1">
                        <div style=" text-align: left; padding-left: 2px;">

                            <!-- <span style="float: left;  clear: both; width: 100%;" [innerHTML]="text2"></span> -->
                            <span style="float: left; padding-top: 7px;">
                                <div class="product__quantity input-number">

                                    <input class="form-control input-number__input" type="number"
                                        style="width: 45px; padding: 18px;" [min]="options.min" [max]="999999"
                                        [disabled]="options.disabled" [readOnly]="options.readonly" name="aantalpakken"
                                        (input)="inputpak()" (blur)="onTouched()" onfocus="this.value=''"
                                        [(ngModel)]="current">

                                    <!-- <input class="form-control input-number__input" type="number"
                                        style="width: 90px; padding: 18px;" [min]="options.min" [max]="options.max"
                                        [disabled]="options.disabled" [readOnly]="options.readonly" name="aantalpakken"
                                        (input)="inputpak()" (blur)="onTouched()" onfocus="this.value=''"
                                        [formControl]="textControl" [(ngModel)]="current"> -->


                                    <!-- <div class="input-number__add" (mousedown)="addpak()"></div>
                                    <div class="input-number__sub" (mousedown)="subpak()"></div> -->
                                </div>

                            </span>

                        </div>
                    </div>

                </div>


            </div>
        </div>




        <div class="col-12 col-md-4"><span
                style="font-size: 18px; float: left; font-weight: bold; background-color: #305696; width: 100%; margin-bottom: 8px; padding: 3px 0px 3px 5px; color: #fff; text-align: center;">
                Kies je ondervloer</span>
            <div style="padding: 8px; border: 1px solid #305696; height: 100%; display: inherit;">


                <div style="margin-bottom: 10px;">

                    <div style="text-align: center; width: 100%; ">
                        <img src="{{ product.combinatieondervloerimg[combinatieondervloer.value] }}"
                            style="margin-right: 10px; border: 1px solid rgb(240, 235, 226); vertical-align: top;"
                            alt="{{this.product.combinatieondervloernaam[combinatieondervloer.value]}}" width="110"
                            height="110">
                    </div>
                    <div style="width: 100%;  display: flex;">
                        <div style="display: flex; width: 50%; float: left; padding-top: 5px;">


                            <a href="javascript:;" (click)="combinatielinks(combinatieondervloer.value)">

                                <img src="/assets/images/icons/rechts-blauw-dik.svg"
                                    style="vertical-align: text-top; transform: rotate(180deg);" width="14"
                                    alt="Blauwe pijl" height="21.3666">
                            </a>

                        </div>

                        <div style="display: block ruby; width: 50%; height: 30px; text-align: right;">

                            <div style="float: right; padding-top: 5px;">


                                <a href="javascript:;" (click)="combinatierechts(combinatieondervloer.value)">

                                    <img src="/assets/images/icons/rechts-blauw-dik.svg"
                                        style="vertical-align: text-top; " width="14" height="21.3666">

                                </a>



                            </div>

                        </div>
                    </div>
                    <div style="text-align: center; width: 100%">
                        <strong>{{ this.aantalondervloer }}x <span
                                [innerHTML]="this.product.combinatieondervloernaam[combinatieondervloer.value]"></span></strong>
                        <!--<br>Warmteweerstand
                        {{ this.product.combinatieondervloerww[combinatieondervloer.value] | number:
                        '1.1-3' }} K/W<br>Geschikt voor: <strong>{{
                            this.product.combinatieondervloergeschikt[combinatieondervloer.value] }}</strong> -->
                        <div style="display: table; margin: auto;">
                            <span class="orangebold" style="font-size: 24px;">{{
                                product.combinatieondervloerprijsactie[combinatieondervloer.value] | currencyFormat }}
                                m<sup>2</sup></span>

                        </div>



                        <span style="padding: 3px 5px 0px 0px; fill: #0090e3; display: inline-block;">


                            <img src="/assets/images/icons/rechts-blauw-dik.svg" class=""
                                style="vertical-align: text-top;" width="10" height="15">

                        </span>
                        <a href="{{ product.combinatieondervloerurl[combinatieondervloer.value] }}"
                            target="_blank">Bekijk productpagina</a>

                    </div>
                </div>
                <br>



                <label for="male"><i style="color: #ff7100; font-weight: bold;">Kies je ondervloer</i></label>
                <select id="male" class="form-control" #combinatieondervloer
                    (change)="callType(combinatieondervloer.value)" [(ngModel)]="selectedOndervloer">


                    <ng-container *ngFor="let questions of this.product.combinatieondervloernaam; let i = index">
                        <option value="{{i}}">{{questions}} ({{this.product.combinatieondervloergeschikt[i]}})
                        </option>
                    </ng-container>



                </select>

            </div>
        </div>
        <div class="col-12 col-md-4">
            <span
                style="font-size: 18px; float: left; font-weight: bold; background-color: #305696; width: 100%;  padding: 3px 0px 3px 5px; color: #fff; text-align: center;">
                Combinatiekorting</span>

            <div style=" padding: 8px; border: 1px solid #305696; height: 100%; display: inherit;">
                <div style="float: left; z-index: 999; position: relative; left: -35px; top: 124px;"
                    class="d-none d-lg-block">
                    <img src="/assets/images/icons/round-equal.svg" class="icon icon--size-6 icon--color-orange"
                        alt="ïcon round">
                </div>

                <div class="d-lg-none">
                    &nbsp;
                </div>


                <div style="clear: both;"></div>
                <div style="width: 50%; float: left;">
                    <div style=" text-align: right; padding-top: 7px; padding-right: 4px;">
                        Aantal pak:
                    </div>
                </div>
                <div style="width: 50%; float: left;  padding-left: 4px;">
                    <div style=" text-align: left;">

                        <!-- <span style="float: left;  clear: both; width: 100%;" [innerHTML]="text2"></span> -->
                        <span style="float: left;">
                            <div class="product__quantity input-number">

                                <input class="form-control input-number__input" type="number"
                                    style="width: 45px; padding: 18px;" [min]="options.min" [max]="999999"
                                    [disabled]="options.disabled" [readOnly]="options.readonly" name="aantalpakken"
                                    (input)="inputpak()" (blur)="onTouched()" onfocus="this.value=''"
                                    [(ngModel)]="current">

                                <!-- <input class="form-control input-number__input" type="number"
                                        style="width: 90px; padding: 18px;" [min]="options.min" [max]="options.max"
                                        [disabled]="options.disabled" [readOnly]="options.readonly" name="aantalpakken"
                                        (input)="inputpak()" (blur)="onTouched()" onfocus="this.value=''"
                                        [formControl]="textControl" [(ngModel)]="current"> -->



                                <!-- <div class="input-number__add" (mousedown)="addpak()"></div>
                                    <div class="input-number__sub" (mousedown)="subpak()"></div> -->
                            </div>

                        </span>
                    </div>
                </div>

                <div style="clear: both;"></div>


                <div style=" padding: 5px 8px 8px 8px; ">

                    <div style="  display: table; margin: auto;">

                        <strong>{{ this.aantalpak }}x {{ product.merknaam }}
                            {{ product.serienaam }} </strong> - {{ product.prijsm2 | currencyFormat }} m<sup>2</sup>
                        <br>
                        <strong>
                            {{ this.aantalondervloer }}x <span
                                [innerHTML]="this.product.combinatieondervloernaam[combinatieondervloer.value]"></span>

                        </strong> - {{ this.product.combinatieondervloerprijsactie[combinatieondervloer.value] |
                        currencyFormat }} m<sup>2</sup>

                    </div>
                    <br>
                    <div style="width: 100%; text-align: center; ">

                        <ng-container
                            *ngIf="product.combinatieondervloerww[combinatieondervloer.value]*1 + product.warmteweerstand*1 <= 0.140">
                            <i>Totale warmteweerstand slechts {{
                                product.combinatieondervloerww[combinatieondervloer.value]*1 + product.warmteweerstand*1
                                |
                                number:
                                '1.1-3' }} m² K/W</i>
                        </ng-container>
                        <ng-container
                            *ngIf="product.combinatieondervloerww[combinatieondervloer.value]*1 + product.warmteweerstand*1 > 0.140">
                            &nbsp;</ng-container>

                    </div>


                    <hr style="clear: both; border: solid 1px #ccc; margin-top: 11px; margin-bottom: 10px;">
                    <div class="container">

                        <div style="display: table; margin: auto;">

                            <span style="color: rgb(0, 150, 0); font-weight: bold; margin: both;">
                                Extra
                                {{ (
                                this.product.combinatieondervloerpaknormaal[combinatieondervloer.value] -

                                this.product.combinatieondervloerpakactie[combinatieondervloer.value]) /

                                this.product.combinatieondervloerpaknormaal[combinatieondervloer.value] * 100 |
                                number:
                                '1.0-0'}}% korting ondervloer
                            </span><br>

                            Van&nbsp;
                            <span style="text-decoration: line-through; color: #999;">€
                                {{
                                this.product.combinatieondervloerprijsnormaal[combinatieondervloer.value] | number:
                                '1.2-2'}} / m<sup>2</sup></span>&nbsp;voor&nbsp;<strong>€ {{
                                +
                                this.product.combinatieondervloerprijsactie[combinatieondervloer.value] | number:
                                '1.2-2'}} / m<sup>2</sup></strong><br>


                            <div class="checkmark" style="float: left;"></div>&nbsp;Levertijd {{
                            product.availability }}
                            dagen
                        </div>
                    </div>


                    <div class="product__actions-item product__actions-item--addtocart"
                        style=" padding: 20px 10px 0px 10px; margin: auto;">
                        <button type="button" class="btn btn-primary btn-lg" style="width: 100%;"
                            [ngClass]="{'btn-loading': addingToCart}" appClick
                            (click)="addToCartCombinatieKorting(combinatieondervloer.value)">




                            <!-- <app-icon style="display: inline-block; vertical-align: text-top;" name="cart-20"
                                        size="20">
                                    </app-icon>&nbsp; Plaats in -->

                            <span class="d-none d-md-block d-lg-none">Winkelmand</span>
                            <span class="d-md-none d-lg-block">Plaats in winkelmand</span>
                        </button>

                        <!-- <app-combinatiekorting (notifyParent)="getMessage($event)"></app-combinatiekorting> -->
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="row d-md-none"><br>
        <br>

        <div class="col-12 text-center">


            <div style="padding-top: 15px;">
                <a href="https://www.feedbackcompany.com/nl-nl/reviews/voordeelvloeren-nl" rel="nofollow"
                    target="_blank">
                    <div style="padding-top: 3px;">
                        <img src="/assets/images/global/ratingstar.svg" alt="Rating" style="vertical-align: top;"
                            width="16" height="16" alt="Icon rating">
                        <img src="/assets/images/global/ratingstar.svg" alt="Rating" style="vertical-align: top;"
                            width="16" height="16" alt="Icon rating">
                        <img src="/assets/images/global/ratingstar.svg" alt="Rating" style="vertical-align: top;"
                            width="16" height="16" alt="Icon rating">
                        <img src="/assets/images/global/ratingstar.svg" alt="Rating" style="vertical-align: top;"
                            width="16" height="16" alt="Icon rating">
                        <img src="/assets/images/global/ratingstar.svg" alt="Rating" style="vertical-align: top;"
                            width="16" height="16" alt="Icon rating">
                    </div>
                </a>
            </div>


            <div>&nbsp;<a href="https://www.feedbackcompany.com/nl-nl/reviews/voordeelvloeren-nl" target="_blank"
                    rel="nofollow" class="blacklink">
                    <ng-container *ngIf="fbcreviews">{{fbcreviews['score']}}</ng-container> / <ng-container
                        *ngIf="fbcreviews">{{fbcreviews['total']}}</ng-container> van
                    <ng-container *ngIf="fbcreviews">{{fbcreviews['count']}}</ng-container> beoordelingen
                </a>
            </div>


            <svg style="margin: auto;" width="100px" height="51px" viewBox="0 0 251 71" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

                <title>FBC-logo</title>

                <defs>
                    <linearGradient x1="-12.3982067%" y1="-10.4568059%" x2="85.5188112%" y2="99.2080422%"
                        id="linearGradient-2">
                        <stop stop-color="#6590FF" offset="0%"></stop>
                        <stop stop-color="#4DC9E2" offset="50.707348%"></stop>
                        <stop stop-color="#35FFC6" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Atom/Logos/Logo/Complete/Colored" fill-rule="nonzero">
                        <g id="FBC-logo">
                            <path
                                d="M115.557,16.675 L111.417,16.675 L111.417,30.616 L106.634,30.616 L106.634,16.675 L104,16.675 L104,14.37 L106.634,13.084 L106.634,11.798 C106.634,9.801 107.126,8.343 108.108,7.423 C109.091,6.503 110.664,6.043 112.828,6.043 C114.48,6.043 115.948,6.288 117.235,6.779 L116.012,10.292 C115.05,9.989 114.161,9.838 113.346,9.838 C112.666,9.838 112.175,10.039 111.872,10.441 C111.569,10.844 111.417,11.358 111.417,11.986 L111.417,13.084 L115.557,13.084 L115.557,16.675"
                                id="Fill-3510" fill="#303C50"></path>
                            <path
                                d="M125.327,16.445 C124.313,16.445 123.518,16.766 122.944,17.41 C122.368,18.053 122.039,18.965 121.956,20.146 L128.667,20.146 C128.646,18.965 128.337,18.053 127.742,17.41 C127.146,16.766 126.341,16.445 125.327,16.445 Z M126.002,31.217 C123.179,31.217 120.973,30.439 119.382,28.881 C117.795,27.323 117,25.117 117,22.263 C117,19.326 117.735,17.055 119.203,15.45 C120.671,13.844 122.703,13.043 125.296,13.043 C127.774,13.043 129.702,13.748 131.082,15.159 C132.462,16.571 133.151,18.52 133.151,21.009 L133.151,23.33 L121.846,23.33 C121.898,24.689 122.299,25.75 123.053,26.513 C123.806,27.276 124.862,27.658 126.221,27.658 C127.277,27.658 128.276,27.549 129.215,27.329 C130.157,27.109 131.14,26.759 132.164,26.278 L132.164,29.979 C131.328,30.397 130.434,30.708 129.483,30.912 C128.531,31.116 127.371,31.217 126.002,31.217 L126.002,31.217 Z"
                                id="Fill-3511" fill="#303C50"></path>
                            <path
                                d="M144.327,16.445 C143.313,16.445 142.518,16.766 141.943,17.41 C141.368,18.053 141.039,18.965 140.955,20.146 L147.667,20.146 C147.646,18.965 147.338,18.053 146.742,17.41 C146.146,16.766 145.34,16.445 144.327,16.445 Z M145.001,31.217 C142.178,31.217 139.972,30.439 138.383,28.881 C136.794,27.323 136,25.117 136,22.263 C136,19.326 136.734,17.055 138.203,15.45 C139.672,13.844 141.702,13.043 144.295,13.043 C146.773,13.043 148.702,13.748 150.082,15.159 C151.462,16.571 152.152,18.52 152.152,21.009 L152.152,23.33 L140.845,23.33 C140.898,24.689 141.299,25.75 142.053,26.513 C142.805,27.276 143.862,27.658 145.22,27.658 C146.277,27.658 147.275,27.549 148.216,27.329 C149.157,27.109 150.139,26.759 151.164,26.278 L151.164,29.979 C150.327,30.397 149.434,30.708 148.483,30.912 C147.53,31.116 146.37,31.217 145.001,31.217 L145.001,31.217 Z"
                                id="Fill-3512" fill="#303C50"></path>
                            <path
                                d="M163.295,26.947 C164.519,26.947 165.415,26.591 165.985,25.881 C166.553,25.17 166.866,23.963 166.918,22.258 L166.918,21.741 C166.918,19.859 166.628,18.511 166.048,17.695 C165.468,16.88 164.524,16.472 163.217,16.472 C162.151,16.472 161.322,16.924 160.731,17.828 C160.14,18.732 159.846,20.047 159.846,21.772 C159.846,23.497 160.143,24.791 160.739,25.653 C161.335,26.515 162.187,26.947 163.295,26.947 Z M161.617,30.757 C159.558,30.757 157.94,29.958 156.764,28.358 C155.588,26.758 155,24.543 155,21.71 C155,18.835 155.598,16.595 156.795,14.99 C157.992,13.384 159.641,12.583 161.743,12.583 C163.949,12.583 165.632,13.44 166.792,15.154 L166.95,15.154 C166.709,13.847 166.589,12.681 166.589,11.657 L166.589,6.043 L171.388,6.043 L171.388,30.444 L167.718,30.444 L166.792,28.171 L166.589,28.171 C165.501,29.895 163.844,30.757 161.617,30.757 L161.617,30.757 Z"
                                id="Fill-3513" fill="#303C50"></path>
                            <path
                                d="M185.217,16.409 C184.036,16.409 183.173,16.772 182.63,17.499 C182.086,18.225 181.804,19.426 181.783,21.097 L181.783,21.615 C181.783,23.497 182.062,24.845 182.621,25.661 C183.181,26.476 184.067,26.884 185.28,26.884 C186.263,26.884 187.044,26.432 187.623,25.528 C188.205,24.624 188.495,23.308 188.495,21.584 C188.495,19.859 188.202,18.565 187.617,17.703 C187.031,16.84 186.231,16.409 185.217,16.409 Z M186.754,12.583 C188.824,12.583 190.444,13.39 191.615,15.006 C192.786,16.621 193.372,18.835 193.372,21.646 C193.372,24.543 192.767,26.785 191.56,28.374 C190.353,29.964 188.709,30.757 186.628,30.757 C184.569,30.757 182.954,30.01 181.783,28.515 L181.454,28.515 L180.654,30.444 L177,30.444 L177,6.043 L181.783,6.043 L181.783,11.72 C181.783,12.441 181.72,13.596 181.595,15.185 L181.783,15.185 C182.901,13.45 184.559,12.583 186.754,12.583 L186.754,12.583 Z"
                                id="Fill-3514" fill="#303C50"></path>
                            <path
                                d="M206.883,22.813 L205.033,22.875 C203.642,22.917 202.607,23.168 201.928,23.628 C201.248,24.088 200.909,24.789 200.909,25.73 C200.909,27.079 201.682,27.752 203.23,27.752 C204.336,27.752 205.224,27.434 205.888,26.796 C206.551,26.159 206.883,25.312 206.883,24.255 L206.883,22.813 Z M208.294,30.936 L207.37,28.552 L207.244,28.552 C206.439,29.567 205.61,30.27 204.758,30.662 C203.906,31.053 202.795,31.249 201.426,31.249 C199.743,31.249 198.417,30.769 197.451,29.807 C196.483,28.845 196,27.476 196,25.699 C196,23.837 196.651,22.465 197.953,21.582 C199.254,20.699 201.217,20.21 203.841,20.116 L206.883,20.021 L206.883,19.254 C206.883,17.476 205.974,16.588 204.155,16.588 C202.752,16.588 201.107,17.01 199.215,17.857 L197.631,14.626 C199.647,13.571 201.886,13.043 204.343,13.043 C206.695,13.043 208.499,13.555 209.753,14.58 C211.008,15.604 211.635,17.163 211.635,19.254 L211.635,30.936 L208.294,30.936 L208.294,30.936 Z"
                                id="Fill-3515" fill="#303C50"></path>
                            <path
                                d="M223.186,31.217 C217.728,31.217 215,28.222 215,22.232 C215,19.253 215.742,16.976 217.226,15.402 C218.711,13.829 220.839,13.043 223.609,13.043 C225.637,13.043 227.456,13.44 229.066,14.234 L227.654,17.935 C226.902,17.632 226.202,17.384 225.553,17.19 C224.905,16.997 224.256,16.9 223.609,16.9 C221.121,16.9 219.877,18.667 219.877,22.201 C219.877,25.63 221.121,27.344 223.609,27.344 C224.528,27.344 225.381,27.221 226.165,26.975 C226.949,26.73 227.733,26.346 228.517,25.823 L228.517,29.916 C227.743,30.408 226.962,30.747 226.173,30.935 C225.382,31.124 224.388,31.217 223.186,31.217"
                                id="Fill-3516" fill="#303C50"></path>
                            <polyline id="Fill-3517" fill="#303C50"
                                points="237.594 20.91 239.679 18.244 244.589 12.912 249.984 12.912 243.021 20.517 250.407 30.444 244.887 30.444 239.838 23.341 237.783 24.987 237.783 30.444 233 30.444 233 6.043 237.783 6.043 237.783 16.926 237.532 20.91 237.594 20.91">
                            </polyline>
                            <path
                                d="M112.826,61.858 C110.337,61.858 108.411,61.092 107.047,59.561 C105.682,58.029 105,55.863 105,53.06 C105,50.186 105.693,47.964 107.078,46.396 C108.463,44.827 110.435,44.043 112.998,44.043 C113.824,44.043 114.65,44.132 115.476,44.31 C116.301,44.488 116.95,44.697 117.42,44.937 L116.62,47.148 C116.045,46.918 115.418,46.728 114.739,46.575 C114.059,46.424 113.457,46.349 112.935,46.349 C109.443,46.349 107.697,48.575 107.697,53.029 C107.697,55.141 108.123,56.761 108.976,57.89 C109.828,59.02 111.09,59.584 112.763,59.584 C114.195,59.584 115.664,59.276 117.169,58.658 L117.169,60.964 C116.019,61.56 114.571,61.858 112.826,61.858"
                                id="Fill-3518" fill="#303C50"></path>
                            <path
                                d="M122.698,52.935 C122.698,55.13 123.138,56.803 124.016,57.953 C124.894,59.103 126.185,59.678 127.889,59.678 C129.593,59.678 130.887,59.106 131.771,57.961 C132.654,56.816 133.096,55.141 133.096,52.935 C133.096,50.75 132.654,49.09 131.771,47.955 C130.887,46.822 129.583,46.254 127.858,46.254 C126.154,46.254 124.868,46.814 124,47.932 C123.132,49.051 122.698,50.718 122.698,52.935 Z M135.793,52.935 C135.793,55.737 135.087,57.924 133.676,59.497 C132.265,61.072 130.313,61.858 127.827,61.858 C126.29,61.858 124.925,61.497 123.733,60.776 C122.542,60.054 121.622,59.02 120.974,57.671 C120.325,56.323 120,54.743 120,52.935 C120,50.133 120.702,47.95 122.103,46.388 C123.503,44.825 125.448,44.043 127.935,44.043 C130.341,44.043 132.251,44.843 133.668,46.443 C135.083,48.042 135.793,50.206 135.793,52.935 L135.793,52.935 Z"
                                id="Fill-3519" fill="#303C50"></path>
                            <path
                                d="M162.909,61.544 L162.909,50.363 C162.909,48.993 162.616,47.966 162.031,47.282 C161.445,46.597 160.536,46.254 159.302,46.254 C157.682,46.254 156.484,46.72 155.711,47.65 C154.936,48.58 154.55,50.013 154.55,51.947 L154.55,61.544 L151.947,61.544 L151.947,50.363 C151.947,48.993 151.654,47.966 151.069,47.282 C150.483,46.597 149.569,46.254 148.325,46.254 C146.694,46.254 145.499,46.743 144.741,47.721 C143.983,48.699 143.603,50.3 143.603,52.527 L143.603,61.544 L141,61.544 L141,44.357 L143.118,44.357 L143.541,46.709 L143.667,46.709 C144.159,45.872 144.851,45.219 145.745,44.749 C146.639,44.279 147.64,44.043 148.747,44.043 C151.435,44.043 153.191,45.016 154.017,46.96 L154.143,46.96 C154.655,46.061 155.397,45.35 156.37,44.827 C157.342,44.305 158.45,44.043 159.694,44.043 C161.639,44.043 163.094,44.542 164.061,45.54 C165.028,46.539 165.512,48.136 165.512,50.331 L165.512,61.544 L162.909,61.544"
                                id="Fill-3520" fill="#303C50"></path>
                            <path
                                d="M178.622,46.254 C176.865,46.254 175.595,46.741 174.811,47.713 C174.027,48.685 173.623,50.233 173.603,52.355 L173.603,52.935 C173.603,55.35 174.006,57.077 174.811,58.117 C175.616,59.158 176.907,59.678 178.684,59.678 C180.169,59.678 181.332,59.077 182.174,57.874 C183.015,56.672 183.436,55.015 183.436,52.904 C183.436,50.76 183.015,49.116 182.174,47.972 C181.332,46.826 180.148,46.254 178.622,46.254 Z M178.998,61.858 C177.879,61.858 176.856,61.652 175.932,61.239 C175.007,60.825 174.23,60.191 173.603,59.333 L173.415,59.333 C173.54,60.337 173.603,61.288 173.603,62.187 L173.603,69.26 L171,69.26 L171,44.357 L173.117,44.357 L173.478,46.709 L173.603,46.709 C174.272,45.768 175.051,45.089 175.94,44.67 C176.829,44.252 177.848,44.043 178.998,44.043 C181.277,44.043 183.036,44.823 184.275,46.38 C185.514,47.938 186.133,50.122 186.133,52.935 C186.133,55.757 185.503,57.95 184.244,59.513 C182.984,61.076 181.235,61.858 178.998,61.858 L178.998,61.858 Z"
                                id="Fill-3521" fill="#303C50"></path>
                            <path
                                d="M194.976,59.677 C196.596,59.677 197.869,59.233 198.794,58.344 C199.72,57.456 200.182,56.211 200.182,54.612 L200.182,53.06 L197.579,53.169 C195.509,53.243 194.017,53.564 193.102,54.134 C192.187,54.704 191.73,55.589 191.73,56.792 C191.73,57.733 192.014,58.449 192.584,58.94 C193.154,59.432 193.951,59.677 194.976,59.677 Z M200.856,61.512 L200.339,59.066 L200.213,59.066 C199.356,60.143 198.501,60.872 197.649,61.253 C196.797,61.635 195.734,61.826 194.459,61.826 C192.754,61.826 191.417,61.387 190.452,60.508 C189.484,59.63 189,58.381 189,56.76 C189,53.29 191.777,51.47 197.328,51.303 L200.245,51.209 L200.245,50.143 C200.245,48.794 199.955,47.798 199.374,47.156 C198.794,46.512 197.866,46.191 196.591,46.191 C195.159,46.191 193.538,46.63 191.73,47.508 L190.93,45.517 C191.777,45.057 192.705,44.696 193.712,44.435 C194.722,44.173 195.734,44.043 196.748,44.043 C198.797,44.043 200.315,44.498 201.303,45.407 C202.291,46.317 202.785,47.775 202.785,49.782 L202.785,61.512 L200.856,61.512 L200.856,61.512 Z"
                                id="Fill-3522" fill="#303C50"></path>
                            <path
                                d="M219.761,61.544 L219.761,50.426 C219.761,49.025 219.442,47.98 218.805,47.289 C218.167,46.599 217.168,46.254 215.81,46.254 C214.011,46.254 212.694,46.741 211.857,47.713 C211.021,48.685 210.602,50.29 210.602,52.527 L210.602,61.544 L208,61.544 L208,44.357 L210.117,44.357 L210.54,46.709 L210.665,46.709 C211.199,45.863 211.946,45.206 212.908,44.742 C213.87,44.276 214.941,44.043 216.122,44.043 C218.193,44.043 219.75,44.542 220.796,45.54 C221.841,46.539 222.364,48.136 222.364,50.331 L222.364,61.544 L219.761,61.544"
                                id="Fill-3523" fill="#303C50"></path>
                            <path
                                d="M225,45.043 L227.792,45.043 L231.556,54.844 C232.381,57.082 232.893,58.697 233.092,59.69 L233.218,59.69 C233.353,59.157 233.639,58.245 234.073,56.953 C234.506,55.662 235.925,51.692 238.33,45.043 L241.121,45.043 L233.735,64.614 C233.003,66.548 232.149,67.92 231.171,68.73 C230.194,69.541 228.993,69.946 227.572,69.946 C226.778,69.946 225.993,69.857 225.22,69.679 L225.22,67.594 C225.795,67.719 226.438,67.782 227.149,67.782 C228.937,67.782 230.212,66.778 230.974,64.77 L231.932,62.324 L225,45.043"
                                id="Fill-3524" fill="#303C50"></path>
                            <g id="Atom/Logos/Logo/Mark/Colored" fill="url(#linearGradient-2)">
                                <path
                                    d="M28.372,30.043 C29.6,30.043 30.595,31.038 30.595,32.265 C30.595,33.493 29.6,34.488 28.372,34.488 L24.668,34.488 C23.442,34.488 22.446,35.485 22.446,36.71 L22.446,64.32 L28.89,60.047 C29.254,59.805 29.681,59.676 30.118,59.676 L45.412,59.676 C46.637,59.676 47.634,58.679 47.634,57.454 L47.634,46.717 C47.634,45.49 48.629,44.494 49.856,44.494 C51.084,44.494 52.079,45.49 52.079,46.717 L52.079,57.454 C52.079,61.13 49.088,64.121 45.412,64.121 L30.788,64.121 L21.452,70.314 C21.081,70.559 20.652,70.684 20.223,70.684 C19.862,70.684 19.501,70.596 19.172,70.42 C18.451,70.032 18,69.28 18,68.461 L18,36.71 C18,33.034 20.992,30.043 24.668,30.043 L28.372,30.043 Z M28.247,11.043 C29.409,11.043 30.469,11.879 30.584,13.035 C30.718,14.366 29.676,15.488 28.374,15.488 L6.667,15.488 C5.44,15.488 4.446,16.483 4.446,17.71 L4.446,45.32 L8.737,42.474 C9.87,41.722 11.406,42.155 11.981,43.387 C12.445,44.384 12.11,45.57 11.194,46.178 L3.452,51.313 C3.081,51.559 2.652,51.683 2.223,51.683 C1.862,51.683 1.502,51.596 1.172,51.419 C0.451,51.032 5.15143483e-13,50.279 5.15143483e-13,49.461 L5.15143483e-13,17.71 C5.15143483e-13,14.028 2.986,11.043 6.667,11.043 L28.247,11.043 Z M68.231,0.043 C71.908,0.043 74.899,3.034 74.899,6.71 L74.899,43.127 C74.899,43.946 74.449,44.698 73.728,45.085 C73.397,45.262 73.037,45.35 72.676,45.35 C72.247,45.35 71.819,45.225 71.448,44.979 L60.836,37.941 L43.667,37.941 C39.992,37.941 37,34.95 37,31.273 L37,6.71 C37,3.034 39.992,0.043 43.667,0.043 L68.231,0.043 Z M68.231,4.488 L43.667,4.488 C42.443,4.488 41.446,5.485 41.446,6.71 L41.446,31.273 C41.446,32.499 42.443,33.496 43.667,33.496 L61.506,33.496 C61.943,33.496 62.37,33.625 62.734,33.867 L70.454,38.986 L70.454,6.71 C70.454,5.485 69.457,4.488 68.231,4.488 Z"
                                    id="Combined-Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
    </div>


    <!-- ///// -->

    <br>




    <div class="row">
        <div class="col-12 col-lg-7 ">




            <div *ngIf="product.typedetail.indexOf('iframe') === -1">
                <app-collapsable-text [text]="product.typedetail" [isProductPage]="true"></app-collapsable-text>
            </div>

            <div [innerHTML]="this.typedetail" *ngIf="product.typedetail.indexOf('iframe') !== -1"> </div>

            <br>

        </div>

        <div class="col-12 col-lg-5">

            <!---!!-->

            <div class="d-none d-md-block"
                *ngIf="product.brochurepdf?.length && product.badges && product.badges[0].length > 0">
                <div style="width: 100%; padding: 16px 16px 16px 0px; display: flow-root;">

                    <div style=" float:left; margin:10px 10px 10px 0px;">
                        <a href="https://downloads.voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf"
                            class="black" target="_blank">
                            <img src="/assets/images/brochure/{{product.brochurepdf}}.jpg" width="230" height="319"
                                style=" margin-right: 7px;" alt="Brochure {{
                                    product.merknaam }} {{
                                    product.serienaam }}">
                        </a>
                    </div>
                    <div style="padding-top: 10px;">
                        <span style="font-weight: bold; font-size: 20px;">Brochure 2025</span><br><br>

                        Blader op je gemak door de nieuwste {{ product.brochurenaam }}
                        en laat je inspireren door de nieuwste trends.<br><Br>

                        {{ product.merknaam }} heeft een volledig assortiment gereedschappen om je vloer
                        makkelijk
                        te
                        leggen en accessoires om de {{ product.merknaam }} vloer af te werken.<br><br>
                    </div>


                    <div>


                        <img src="/assets/images/logos/pdf.svg" class="img-fluid" alt="PDF download" width="15px"
                            style="vertical-align: unset;">&nbsp;&nbsp;<a
                            href="https://downloads.Voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf"
                            target="_blank">Download {{ product.brochurenaam }}</a>
                    </div>


                </div>

            </div>

            <!---!!-->


            <div class="d-none d-md-block">
                <ng-container *ngIf="(obj | json) != '[]' ">
                    <div class="block-header">
                        <span class="block-header__title">Ook in deze {{product.serienaam}} serie </span>
                        <div class="block-header__divider"></div>

                    </div>

                    <div class="row">
                        <ng-container *ngFor="let product2 of obj;">
                            <div *ngIf="product.id != product2.id" class=" col-md-4 col-lg-6 col-xl-4 px-1 pb-2 my-1"
                                style="display: flex; flex-wrap: wrap;">


                                <div class="product-card">

                                    <div style="padding: 8px; flex-shrink: 0;"><a routerLink="{{product2.url}}"
                                            class="ng-star-inserted"><img class="responsiveimg" loading="lazy"
                                                width="200" height="200" alt="{{product2.title}}"
                                                src="{{product2.image}}"></a>

                                    </div>
                                    <div class="product-card__info" style="padding: 2px 8px 8px 8px;">
                                        <div class="product-card__name"><a appclick=""
                                                routerLink="{{product2.url}}">{{product2.merknaam}}
                                                {{product2.title}}</a>
                                        </div>

                                    </div>
                                    <div class="product-card__actions"
                                        style="width: 100%; text-align: center; padding-bottom: 8px;">

                                        <div class="product-card__prices" [innerHtml]="product2.price"
                                            style="font-size: 18px; padding: 5px 0px 8px 0px;">

                                        </div>
                                        <div><button type="button" routerLink="{{product2.url}}"
                                                class="btn btn-primary product-card__addtocart">
                                                Informatie
                                            </button></div>
                                    </div>
                                </div>

                            </div>
                        </ng-container>


                    </div>

                    <!-- <div class="products-view__list products-list" [attr.data-layout]="'grid-3-sidebar'"
                        [attr.data-with-features]="true">
                        <div class="products-list__body">

                            <ng-container *ngFor="let product2 of obj;">
                                <div *ngIf="product.id != product2.id" class=" products-list__item"
                                    style="display: flex; min-width: 150px;">


                                    <div class="product-card">

                                        <div style="padding: 8px; flex-shrink: 0;"><a routerLink="{{product2.url}}"
                                                class="ng-star-inserted"><img class="responsiveimg" loading="lazy"
                                                    width="200" height="200" alt="{{product2.title}}"
                                                    src="{{product2.image}}"></a>

                                        </div>
                                        <div class="product-card__info" style="padding: 2px 8px 8px 8px;">
                                            <div class="product-card__name"><a appclick=""
                                                    routerLink="{{product2.url}}">{{product2.merknaam}}
                                                    {{product2.title}}</a>
                                            </div>

                                        </div>
                                        <div class="product-card__actions" style="width: 100%; text-align: center;">

                                            <div class="product-card__prices" [innerHtml]="product2.price"
                                                style="font-size: 18px; padding: 5px 0px 8px 0px;">

                                            </div>
                                            <div><button type="button" routerLink="{{product2.url}}"
                                                    class="btn btn-primary product-card__addtocart">
                                                    Informatie
                                                </button></div>
                                        </div>
                                    </div>

                                </div>
                            </ng-container>
                        </div>
                    </div> -->

                    <br>
                    <button type="button" style="width: 100%; height: auto;"
                        routerLink="/{{product.categorieslug | lowercase }}/{{product.slugserie}}"
                        class="btn btn-secondary">
                        Bekijk de volledige {{
                        product.merknaam }} {{
                        product.serienaam }}
                        collectie
                    </button>



                </ng-container>
            </div>
        </div>

    </div>
    <br class="d-none d-md-block">
    <div class=" d-md-none ">
        <span
            style=" font-weight: bold; font-size: 20px; padding-bottom: 5px; padding-bottom: 3px; display: block;">Plus-
            en minpunten</span>
        <ul class="list" style="margin-bottom: 0px;">

            <li *ngFor="let item of product.pluspunten; let i = index" class="list__item ">

                <div class="icon-with-text">
                    <div class="icon-with-text__icon">


                        <svg class="icon icon--color-green" aria-hidden="true" viewBox="0 0 99 99" focusable="false">

                            <circle cx="49.5" cy="49.5" r="49.5"></circle>
                            <path fill="#FFFFFF"
                                d="M49.5 21c-3 0-5.5 2.3-5.5 5.2V44H26.2c-3 0-5.2 2.6-5.2 5.5 0 3 2.3 5.5 5.2 5.5H44v17.8c0 3 2.6 5.2 5.5 5.2 3 0 5.5-2.3 5.5-5.2V55h17.8c3 0 5.2-2.6 5.2-5.5 0-3-2.3-5.5-5.2-5.5H55V26.2c0-3-2.6-5.2-5.5-5.2z">
                            </path>


                        </svg>

                    </div>
                    <div class="icon-with-text__text">
                        {{item}} </div>
                </div>
            </li>
            <li *ngFor="let item of product.minpunten; let i = index" class="list__item ">

                <div class="icon-with-text">
                    <div class="icon-with-text__icon">


                        <svg class="icon icon--color-raingrey" aria-hidden="true" viewBox="0 0 99 99" focusable="false">

                            <circle cx="49.5" cy="49.5" r="49.5"></circle>

                            <path fill="#FFFFFF"
                                d="M72.8 55c3 0 5.2-2.6 5.2-5.5 0-3-2.3-5.5-5.2-5.5H26.2c-3 0-5.2 2.6-5.2 5.5 0 3 2.3 5.5 5.2 5.5">
                            </path>

                        </svg>

                    </div>
                    <div class="icon-with-text__text">
                        {{item}} </div>
                </div>
            </li>
        </ul>
        <br>

    </div>



    <div style="border: 2px solid #f8f4ee; width: 100%; padding: 16px;" class="d-md-none"
        *ngIf="product.brochurepdf?.length">
        <a href="https://downloads.voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf" target="_blank"
            style="margin: auto; display: block; width: 230px;">
            <img src="/assets/images/brochure/{{product.brochurepdf}}.jpg" width="230" height="319"
                style="float: left; margin-bottom: 10px;" alt="Brochure {{
                    product.merknaam }} {{
                    product.serienaam }}">
        </a>
        <div style="display: block; clear: both;">
            <span style=" font-weight: bold; font-size: 20px; ">Brochure 2025</span><br>

            Blader op je gemak door de nieuwste {{ product.brochurenaam }}
            en laat je inspireren door de nieuwste trends.<br><Br>

            {{ product.merknaam }} heeft een volledig assortiment gereedschappen om je vloer makkelijk te
            leggen en accessoires om de {{ product.merknaam }} vloer af te werken.<br><br>
            <img src="/assets/images/logos/pdf.svg" class="img-fluid" alt="PDF download" width="15" height="15.77"
                style="vertical-align: unset;">&nbsp;&nbsp;<a
                href="https://downloads.voordeelvloeren.nl/pdf/product/{{product.brochurepdf}}.pdf"
                target="_blank">Download
                {{ product.merknaam }} brochure</a>
        </div>

    </div>
    <br>


    <div class="d-md-none">

        <ng-container *ngIf="(obj | json) != '[]' ">
            <div class="block-header">
                <span class="block-header__title">Ook in deze {{product.serienaam }} serie </span>
                <div class="block-header__divider"></div>

            </div>
            <div class="products-view__list products-list" [attr.data-layout]="'grid-3-sidebar'"
                [attr.data-with-features]="true">
                <div class="products-list__body">

                    <ng-container *ngFor="let product2 of obj;">
                        <div *ngIf="product.id != product2.id" class=" products-list__item"
                            style="display: flex; min-width: 150px;">


                            <div class="product-card">

                                <div style="padding: 8px; flex-shrink: 0;"><a routerLink="{{product2.url}}"
                                        class="ng-star-inserted"><img class="responsiveimg" loading="lazy" width="200"
                                            height="200" alt="{{product2.title}}" src="{{product2.image}}"></a>

                                </div>
                                <div class="product-card__info" style="padding: 2px 8px 8px 8px;">
                                    <div class="product-card__name"><a appclick=""
                                            ng-reflect-router-link="/product/573/plakplint-univers"
                                            routerLink="{{product2.url}}">{{product2.title}}</a>
                                    </div>

                                </div>
                                <div class="product-card__actions" style="width: 100%;">

                                    <div class="product-card__prices price_xs_24" [innerHtml]="product2.price"
                                        style=" font-size: 18px; padding: 10px 0px 8px 0px; float: left;">

                                    </div>
                                    <div style="float: right;"><button type="button" routerLink="{{product2.url}}"
                                            class="btn btn-primary product-card__addtocart">
                                            Informatie
                                        </button></div>
                                </div>
                            </div>

                        </div>
                    </ng-container>
                </div>
            </div>

            <br>
            <button type="button" style="width: 100%; height: auto;"
                routerLink="/{{product.categorieslug | lowercase }}/{{product.slugserie}}" class="btn btn-secondary">
                Bekijk de volledige {{
                product.merknaam }} {{
                product.serienaam }}
                collectie
            </button>


            <br><br>
        </ng-container>
    </div>
</div>
